<div
  class="layout-wrapper"
  (click)="onLayoutClick()"
  [ngClass]="{
    'layout-static': menuMode === 'static',
    'layout-overlay': menuMode === 'overlay',
    'layout-slim': menuMode === 'slim',
    'layout-horizontal': menuMode === 'horizontal',
    'layout-sidebar': menuMode === 'sidebar',
    'layout-sidebar-static':
      menuMode === 'sidebar' && appSidebarService.sidebarStatic,
    'layout-overlay-active': overlayMenuActive,
    'layout-mobile-active': staticMenuMobileActive,
    'layout-static-inactive': staticMenuDesktopInactive && menuMode === 'static'
  }"
>
  <div class="layout-main">
    <mx-topbar *ngIf="isMobile() || isOverlay() || isHorizontal()"></mx-topbar>

    <mx-menu
      *ngIf="!isMobile() && (isStatic() || isSlim() || isSidebar())"
    ></mx-menu>

    <mx-breadcrumb></mx-breadcrumb>

    <div class="layout-main-content">
      <div [style]="'height: calc(100vh - 185px)'">
        <router-outlet></router-outlet>
      </div>
    </div>

    <!-- <mx-footer></mx-footer> -->
  </div>
</div>
